module.exports = __webpack_public_path__ + "img/4532f5eaf10c731569675d5fef41e59b.8ee09bb2.png";